import PdfViewerDynamic from "@/components/PdfViewer/PdfViewerDynamic";
import { FC } from "react";

type PdfViewerBlockProps = {
  sourceUrl: string;
};

export const PdfViewerBlock: FC<PdfViewerBlockProps> = ({ sourceUrl }) => (
  <PdfViewerDynamic url={sourceUrl} />
);
